import { Flex } from '@chakra-ui/react'
import RouterUrl from '@constants/router.constant'
import Button from '@modules/common/components/button'
import Link from 'next/link'

const SignInPrompt = () => {
  return (
    <Flex
      bg={'white'}
      flexDirection={{ base: 'column', sm: 'column', md: 'row' }}
      justifyContent={'space-between'}
    >
      <div>
        <h2 className="text-xl-semi sm:text-md font-itc">
          Already have an account?
        </h2>
        <p className="mt-2 text-gray-700 text-sm-regular text-base-regular">
          Sign in for a better experience.
        </p>
      </div>
      <div className="mt-3">
        <Link href={RouterUrl.AUTH.LOGIN}>
          <div>
            <Button className="w-auto" variant="secondary">
              Sign in
            </Button>
          </div>
        </Link>
      </div>
    </Flex>
  )
}

export default SignInPrompt
